import React from "react";
import "./Clients.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Gallery from "../5.Gallery/Gallery";

const Clients = () => {
  const handleDownloadBomberos = () => {
    setTimeout(() => {
      const filePath = require("../../assets/docs/Clientes_Habilitacion_Bomberos.pdf");
      const link = document.createElement("a");
      link.href = filePath;
      link.download = "Habilitaciones_Ante_Bomberos.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 1000); // 1000ms = 1 second delay
  };
  const handleDownloadPrivadas = () => {
    setTimeout(() => {
      const filePath = require("../../assets/docs/Clientes_Obras_Privadas.pdf");
      const link = document.createElement("a");
      link.href = filePath;
      link.download = "Obras_De_Construccion.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 1000); // 1000ms = 1 second delay
  };

  return (
    <>
      <div className="container-c" id="clients">
        <div className="">
          <h2 className="title-c">Clientes</h2>
          <Gallery />
          <div className="download-container">
            <FontAwesomeIcon icon={faDownload} className="icon-c" />
            <p className="text-c">
              Para conocer todos los clientes que confían en nosotros, haz clic:
            </p>
            <span className="clickable" onClick={handleDownloadBomberos}>
              - Habilitaciones ante bomberos
            </span>
            <span className="clickable" onClick={handleDownloadPrivadas}>
              - Obras de construcción
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Clients;
